import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { projectsAPI } from '../services/api';
import Loading from '../components/Loading';
import { useToast } from '../context/ToastContext';

const Projects = () => {
  const toast = useToast();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ name: '', description: '', slug: '' });

  useEffect(() => {
    loadProjects();
  }, []);

  const loadProjects = async () => {
    try {
      const response = await projectsAPI.getAll();
      setProjects(response.data.projects);
    } catch (error) {
      console.error('Error cargando proyectos:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await projectsAPI.create(formData);
      setShowModal(false);
      setFormData({ name: '', description: '', slug: '' });
      loadProjects();
    } catch (error) {
      toast.error(error.response?.data?.error || 'Error creando proyecto');
    }
  };

  if (loading) return <Layout><Loading /></Layout>;

  return (
    <Layout>
      <div className="px-4 sm:px-0">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Proyectos</h1>
          <button onClick={() => setShowModal(true)} className="btn-primary">Nuevo Proyecto</button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project) => (
            <Link key={project.id} to={`/projects/${project.id}`} className="card hover:shadow-lg transition-shadow">
              <h3 className="text-xl font-bold mb-2">{project.name}</h3>
              <p className="text-gray-600 mb-4">{project.description}</p>
              <div className="flex justify-between text-sm text-gray-500">
                <span>{project.attendee_count || 0} asistentes</span>
                <span className={`px-2 py-1 rounded ${project.is_active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`}>
                  {project.is_active ? 'Activo' : 'Inactivo'}
                </span>
              </div>
            </Link>
          ))}
        </div>

        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-8 max-w-md w-full">
              <h2 className="text-2xl font-bold mb-4">Nuevo Proyecto</h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="label">Nombre</label>
                  <input type="text" className="input-field" value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    onBlur={(e) => setFormData({
                      ...formData,
                      slug: formData.slug || e.target.value.toLowerCase().replace(/\s+/g, '-')
                    })} required />
                </div>
                <div>
                  <label className="label">Descripción</label>
                  <textarea className="input-field" value={formData.description}
                    onChange={(e) => setFormData({...formData, description: e.target.value})} rows="3" />
                </div>
                <div>
                  <label className="label">Slug (URL)</label>
                  <input type="text" className="input-field" value={formData.slug}
                    onChange={(e) => setFormData({...formData, slug: e.target.value.toLowerCase().replace(/\s+/g, '-')})} required />
                  <p className="text-xs text-gray-500 mt-1">URL: /form/{formData.slug}</p>
                </div>
                <div className="flex space-x-4">
                  <button type="submit" className="btn-primary flex-1">Crear</button>
                  <button type="button" onClick={() => setShowModal(false)} className="btn-secondary flex-1">Cancelar</button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Projects;
